
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeature, 
  CharacterFeatureBase,
  PactBoon, 
} from "@dndModels";

export class CharacterPactBoon extends CharacterFeatureSource {
  source: PactBoon | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (this.source_id === "" && obj.pact_boon_id) {
        this.source_id = obj.pact_boon_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        const char_features: CharacterFeature[] = [];
        obj.features.forEach((o: any) => {
          char_features.push(new CharacterFeature(o));
        });
        const char_feature_base = new CharacterFeatureBase();
        
        char_feature_base.source_id = this.source_id;
        char_feature_base.source_name = this.name;
        char_feature_base.source_type = "PactBoon";
        // char_feature_base.root_id = this.source_id;
        // char_feature_base.root_name = this.source_name;
        // char_feature_base.root_type = "Class";
        char_feature_base.ancestries = [...this.ancestries.map(o => { return {...o}; })];
        char_feature_base.features = char_features;
        this.char_feature_bases.push(char_feature_base);
      }
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
    };
  }

  clone(drop_ids = false): CharacterPactBoon {
    const clone = new CharacterPactBoon();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterPactBoon, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source?.clone()??null;
  }
}